
import $ from 'jquery';
jQuery.noConflict();

export function youtubeFunctions() {
        // Change YouTube video based on playlist selection
        $('.yt-api-video-item:first-child').addClass('active');

        var $iframe =  $('.vid-frame');
        var $videoItem = $('.yt-api-video-item');
        $videoItem.click(function () {
            var $this = $(this);
            $('.vid-frame').attr('src', $this.attr('data-video'));
            $('.vid-frame').attr('srcdoc', "<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=" + $this.attr('data-video') + "?autoplay=1><img src='" + $this.attr('data-thumbnail') + "' alt='" + $this.attr('data-title') + "'><span>&#x25BA;</span></a>")
            $iframe.removeClass('active');
            $('.yt-api-video-item').removeClass('active');
            $(this).addClass('active');
        });

        if ( ($iframe.data('videoid')) === undefined ) {
            $('.yt-api-container').parent().hide();
        } else {
            $('.yt-api-container').parent().show();
        }
    }

    export function youtubeStateChangeFunctions() {
        /* Slick needs no get Reinitialized on window Resize after it was destroyed */
        $('.yt-api-video-list').each(function(){
        var $carousel = $(this);
        /* Initializes a slick carousel only on mobile screens */
        // slick on mobile
        if ($(window).width() > 700) {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        }
        else{
            if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    infinite: false,
                    rows: 0,
                    lazyLoad: 'ondemand',
                    prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
                    nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
                    responsive: [
                        {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        },
                        },
                        {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        },
                        }
                    ]
                });
            }
        }
    });
    }
